<template>
  <div
    ref="alert-box"
    :class="`cheetah-alert-box cheetah-alert-box__${type || 'information'}`"
  >
    <div class="cheetah-alert-box__content">
      <font-awesome-icon
        v-if="with_icon"
        :icon="['fas', 'exclamation-circle']"
        @click="close"
      />
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertBoxComponent',
  props: ['type', 'with_icon'],
  methods: {
    close() {
      this.$refs['alert-box'].classList.add('cheetah-alert-box__close');

      setTimeout(() => {
        this.$refs['alert-box'].style.display = 'none';
      }, 300);
    }
  },
};
</script>

<style lang="scss" scoped>

.cheetah-alert-box {
  position: relative;
  border-radius: 4px;
  padding: 10px;
  color: #080D3ACC;

  transition: all 0.3s;
  margin-bottom: 12px;

  &__information {
    background: #A6D3FE;
  }

  &__warning {
    background: #F9EDAB;

    > div svg:first-child {
      color: #FF6156;
    }
  }

  &__danger {
    background: #FCEDE9;

    > div svg:first-child {
      color: #EB4E2A;

    }
  }

  &__content {
    display: flex;
    align-items: center;

    svg {
      font-size: 20px;
      margin-right: 12px;
    }

    span {
      font-family: 'Lato', sans-serif;
      font-size: 16px;
      font-weight: 700;
    }
  }

  &__close {
    visibility: hidden;
    opacity: 0;
  }


  > svg {
    position: absolute;
    top: 0;
    right: 0;

    font-size: 10px;
    color: #FFFFFF;

    margin: 15px 15px 0px 0px;
    cursor: pointer;
  }
}

.alert-tag > .cheetah-alert-box {
  &__content {
    flex-direction: column;

    span {
      padding-top: 5px;
      text-align: center;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/commons/AlertBoxNewComponent.vue